// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customCardWrapper {
  padding: 20px;
}
.customCardWrapper .cont {
  display: grid;
  grid-template-columns: 34px auto;
  align-items: flex-start;
  column-gap: 14px;
}
.customCardWrapper .cont .icon {
  height: 32px;
  width: 32px;
  background-color: #f8fafc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.customCardWrapper .cont .cardText h2 {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0em;
  line-height: 1;
  margin: 0;
  padding-bottom: 14px;
}
.customCardWrapper .cont .cardText h4,
.customCardWrapper .cont .cardText a {
  color: #a3a3a3;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0em;
  line-height: 1.5;
  margin: 0;
  padding-bottom: 0;
}
.customCardWrapper .cont .cardText h4 span,
.customCardWrapper .cont .cardText a span {
  font-size: 12px;
}
@media (min-width: 280px) and (max-width: 480px) {
  .customCardWrapper {
    padding: 20px 0px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomComponents/CustomCard/CustomCard.less"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;AAAA;EAGI,aAAA;EACA,gCAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;AANA;EAQM,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACN;AAfA;EAkBQ,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,oBAAA;AAAR;AAvBA;;EA2BQ,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AAAR;AAjCA;;EAqCU,eAAA;AAAV;AAsCA;EACE;IACE,qBAAA;EApCF;AACF","sourcesContent":["@import \"../../../assets/Styles/variables.less\";\n\n.customCardWrapper {\n  padding: 20px;\n  .cont {\n    display: grid;\n    grid-template-columns: 34px auto;\n    align-items: flex-start;\n    column-gap: 14px;\n    .icon {\n      height: 32px;\n      width: 32px;\n      background-color: #f8fafc;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .cardText {\n      h2 {\n        font-size: 14px;\n        font-weight: 600;\n        letter-spacing: 0em;\n        line-height: 1;\n        margin: 0;\n        padding-bottom: 14px;\n      }\n      h4,\n      a {\n        color: #a3a3a3;\n        font-size: 14px;\n        font-weight: 400;\n        letter-spacing: 0em;\n        line-height: 1.5;\n        margin: 0;\n        padding-bottom: 0;\n        // max-height: 75px;\n        // overflow: scroll;\n        span {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n@media (min-width: 481px) and (max-width: 767px) {\n}\n\n@media (min-width: 280px) and (max-width: 480px) {\n  .customCardWrapper {\n    padding: 20px 0px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
